export default __webpack_public_path__ + "static/media/iaeCorner00.f6800844.png";